import script from "./InscriptionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InscriptionPage.vue?vue&type=script&setup=true&lang=js"

import "./InscriptionPage.vue?vue&type=style&index=0&id=45cb61aa&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45cb61aa"]])

export default __exports__